import React, { useContext } from 'react'
import StoreContext from '../../providers/storesContext'
import SelectableCitationItem from './SelectableCitationItem'

const SelectableCitations = () => {
  const { licenseStore } = useContext(StoreContext)
  const toggleSelect = (citationId) => {
    licenseStore.toggleCitation(citationId)
  }

  return (
    <div>
      <div className="font-bold pb-3">Violations</div>
      {licenseStore.license.citations.map((citation) => (
        <SelectableCitationItem
          citation={citation}
          handleClick={() => {
            toggleSelect(citation.id)
          }}
          key={`citation_${citation.id}`}
        />
      ))}
    </div>
  )
}

export default SelectableCitations
